import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditBusinessSupportRequestResolution extends TermCreateEdit {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "businesss_support_request_resolution";
  }
}
